import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { PipesModule } from '../../pipes/pipes.module';
import { GridComponent } from './grid.component';

@NgModule({
    declarations: [GridComponent],
    exports: [GridComponent],
    imports: [TwcModule, TranslateModule, FormsModule, CommonModule, PipesModule, DirectivesModule],
})
export class GridModule {}
